// extracted by mini-css-extract-plugin
export default {"authorizePage":"rematch-waiting_authorizePage__jiKdl","rematchGif":"rematch-waiting_rematchGif__b8PUC","rotate":"rematch-waiting_rotate__d-9VT"};